var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_line 1",
    clipPath: "url(#clip0_386_2451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M13.3333 2.5C13.7607 2.5 14.1129 2.8217 14.1611 3.23615L14.1667 3.33333V4.16667H15.8333C16.712 4.16667 17.4318 4.84656 17.4954 5.70895L17.5 5.83333V15.8333C17.5 16.712 16.8201 17.4318 15.9577 17.4954L15.8333 17.5H4.16667C3.28803 17.5 2.5682 16.8201 2.50457 15.9577L2.5 15.8333V5.83333C2.5 4.9547 3.1799 4.23486 4.04228 4.17124L4.16667 4.16667H5.83333V3.33333C5.83333 2.8731 6.20643 2.5 6.66667 2.5C7.09403 2.5 7.44626 2.8217 7.49439 3.23615L7.5 3.33333V4.16667H12.5V3.33333C12.5 2.8731 12.8731 2.5 13.3333 2.5ZM15.8333 10H4.16667V15.8333H15.8333V10ZM15.8333 5.83333H4.16667V8.33333H15.8333V5.83333Z",
    fill: "#969DAB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_2451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.115c84793a0713ee54b7832af15e28ba.svg";
export { ForwardRef as ReactComponent };